<template>
  <div>
    <i class="fa fa-check text-success"></i>
    Feedback van minimaal {{ amount }} reviewers
  </div>
</template>

<script>
export default {
  name: 'NumberOfReviewers',
  props: {
    amount: {
      type: Number,
      default() {
        return 250;
      },
    },
  },
};
</script>
